import { render, staticRenderFns } from "./ImportLeadsSidebar.vue?vue&type=template&id=2ca5a96f&scoped=true"
import script from "./ImportLeadsSidebar.vue?vue&type=script&lang=js"
export * from "./ImportLeadsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ImportLeadsSidebar.vue?vue&type=style&index=0&id=2ca5a96f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5a96f",
  null
  
)

export default component.exports